import 'babel-polyfill';
import 'script-loader!node_modules/jquery/dist/jquery.min.js';

// uncomment if you need to do expand/collapse:
// import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse.js';
// import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition.js';
import moment from 'js/lib/moment.js';


import { Global } from 'js/common/global.js';
import { OnReady } from 'js/components/Util/Browser.js';
import { Yext } from 'js/components/Soy2js/Soy2js.js'; // NOTE: if not using soy2js, replace with window.Yext = window.Yext || {};

import { DistanceCalculator } from 'ts/components/DistanceCalculator/index.ts'; /* TODO: remove if unused */
import { Sniffer } from 'ts/components/Sniffer/index.ts'; /* TODO: remove if unused */

import { Cookies } from 'js/components/Cookies/index.js'; /* TODO: remove if unused */
import { Corsair } from 'js/components/Corsair/index.js'; /* TODO: remove if unused */
import { Description } from 'js/components/Description/index.js'; /* TODO: remove if unused */
import { Events } from 'js/components/Events/index.js'; /* TODO: remove if unused */
import { GoogleAdwords } from 'js/components/GoogleAdwords/index.js'; /* TODO: remove if unused */
import { GoogleAnalytics } from 'js/components/GoogleAnalytics/index.js'; /* TODO: remove if unused */
import { Image } from 'js/components/Image/index.js'; /* TODO: remove if unused */
import { Instagram } from 'js/components/Instagram/index.js'; /* TODO: remove if unused */
import { LocationHours } from 'js/components/LocationHours/index.js'; /* TODO: remove if unused */
import { Maps } from 'js/components/Maps/index.js'; /* TODO: remove if unused */
import { Reviews } from 'js/components/Reviews/index.js'; /* TODO: remove if unused */
import { VectorMap } from 'js/components/VectorMap/index.js'; /* TODO: remove if unused */
import { YoutubeEmbed } from 'js/components/YoutubeEmbed/index.js'; /* TODO: remove if unused */

import { LocationMap } from 'js/location/modules/LocationMap.js';
import { Instance as MapsAPI } from 'js/components/Maps/GoogleMapsAPI.js';

Yext.Maps = Maps;

Global.init();
GoogleAdwords.init();
GoogleAnalytics.enableAutotracking('yext');

OnReady(() => {
  Maps.loadAndRun();
  LocationHours.loadAndRun();
  MapsAPI.load();

  // In order to JS in the translated abbreviation for the month.
  const localizedMonths = JSON.parse(document.querySelector('#js-localizedMonths').innerText);
  let hoursTableDays = document.querySelectorAll('.js-location-hours-date');

  for (let hoursDay of hoursTableDays) {
    let dataRow = hoursDay.dataset.row;
    //get time from start of week instead of current day,
    //allows for adding index of day in hours table
    let dayIndex = parseInt(dataRow);
    let time;

    if (dayIndex + 1 < moment().day()) {
      let localMonth = localizedMonths[moment().day(dayIndex + 8).format("MMMM")];
      time = document.createTextNode(moment().day(dayIndex + 8).format("D") + " " + localMonth); // 5  Jul
    }
    else {
      let localMonth = localizedMonths[moment().startOf('isoweek').add(parseInt(dataRow), 'd').format("MMMM")];
      time = document.createTextNode(moment().startOf('isoweek').add(parseInt(dataRow), 'd').format("D") + " " + localMonth); // 5  Jul
    }

    hoursDay.appendChild(time);
  }

  // Change color of clock.svg on NAP if the hours are currently open.
  let hoursTableToday = document.querySelector('.NAP-hoursTableToday .c-location-hours-today');

  if (hoursTableToday.classList.contains('js-color')) {
    document.querySelector('.js-clock').classList.add('js-color');
  }

  if (hoursTableToday.classList.contains('js-is-open')) {
    document.querySelector('.js-clock').classList.add('js-is-open');
  }


  // - The un-minified file is different than the minified one :/
  // - Uncomment the following if using JVector map
  // VectorMap.autorun();
});
